import VanillaTilt from 'vanilla-tilt'
import CONFIG from '@js/config'
import utils from '@js/utils'
import 'paginationjs'
import 'paginationjs/dist/pagination.css'
import '@css/components/pagination.scss'
import '@js/app'
import scrollbar from '@js/scrollbar'

import '@comp/animate_title/animate_title'
import '@comp/animate_title/animate_title.scss'

import '@comp/note/note.scss'

import './banner/banner.scss'

import compNewsCard from './news_card/news_card.ejs'
import './news_card/news_card.scss'

import BannerSwiper from '@comp/banner_swiper/banner_swiper'

import './style.scss'
import { trackSection } from '@/scripts/ga'

const pageLimit = 6

function fetchFeaturedNews (cb) {
    $.ajax({
        type: 'GET',
        url: `${CONFIG.API_BASE}feature_news`,
        dataType: 'json',
        success: function (msg) {
            if (msg.message) {
                return cb(new Error(msg.message))
            }
            let result = []
            msg.forEach(row => {
                result.push({
                    title: row.work_company,
                    desc: row.title,
                    bgUrl: row.slide_banner,
                    link: `news_detail.html?id=${row.id}`,
                    track: `Featured News #${row.title}`
                })
            })

            return cb(null, {
                count: result.length,
                rows: result
            })
        },
        error: function (err) {
            console.log('err', err)
            location.href = '404.html'
        }
    })
}

function fetchList (pageCurrent, cb) {
    $.ajax({
        type: 'GET',
        url: `${CONFIG.API_BASE}news`,
        data: {
            page: pageCurrent,
            limit: pageLimit
        },
        dataType: 'json',
        success: function (msg) {
            if (msg.message) {
                return cb(new Error(msg.message))
            }
            let result = []
            msg.rows.forEach(row => {
                result.push({
                    desc: row.title,
                    bgUrl: row.cover,
                    date: utils.timeChange(new Date(row.createdAt).getTime()),
                    link: `news_detail.html?id=${row.id}`,
                    track: `News #${row.title}`
                })
            })

            return cb(null, {
                count: msg.count,
                total: new Array(msg.count),
                rows: result
            })
        },
        error: function (err) {
            console.log('err', err)
            location.href = '404.html'
        }
    })
}

$(() => {
    trackSection('News')

    let pageCurrent = utils.getURLParam('page') || 1

    fetchFeaturedNews(function (err, result) {
        if (err) {
            location.href = '404.html'
            return
        }

        let option = {}

        if (result.count <= 1) {
            option = {
                loop: false,
                pagination: false,
                autoplay: false
            }
        }
        const swiper = new BannerSwiper(result.rows, 'news-banner-swiper', option)
        swiper.init()
    })

    const $paginationWrap = $('#pagination-wrap')
    fetchList(pageCurrent, function (err, result) {
        if (err) {
            location.href = '404.html'
            return
        }
        let newsListHtml = ''
        result.rows.forEach((item) => {
            newsListHtml += compNewsCard({
                ...item
            })
        })
        $('#news-list-wrap').html(newsListHtml)

        VanillaTilt.init(document.querySelectorAll('.tilt-link'), {
            max: 2,
            speed: 600
        })

        $paginationWrap.pagination({
            dataSource: result.total,
            showPrevious: false,
            showNext: false,
            pageSize: pageLimit
        })
    })
    let lock = false
    $paginationWrap.addHook('afterPageOnClick', function () {
        if (lock) return
        lock = true
        $paginationWrap.pagination('disable')
        fetchList($paginationWrap.pagination('getSelectedPageNum'), function (err, result) {
            if (err) {
                location.href = '404.html'
                return
            }
            let newsListHtml = ''
            result.rows.forEach((item) => {
                newsListHtml += compNewsCard({
                    ...item
                })
            })
            $('#news-list-wrap').html(newsListHtml)

            VanillaTilt.init(document.querySelectorAll('.tilt-link'), {
                max: 2,
                speed: 600
            })

            lock = false
            $paginationWrap.pagination('enable')

            const scrollHeight = $('.news-banner').height() + $('header').height() + 100
            $('html, body').animate({ scrollTop: scrollHeight }, 150)
        })
    })

    scrollbar.init()
})
